import { Box } from "@mui/material";
import React from "react";

export function GoiBinsoParagraph({
  descriptions = [
    "※ 빈소 예상 비용은 e하늘 장사정보시스템(보건복지부) 기준이며,(주)고이장례연구소는 시설과 무관합니다.",
    "※ 실제 비용은 상황에 따라 달라질 수 있습니다.",
  ],
}: {
  descriptions?: string[];
}) {
  return (
    <Box
      component="p"
      sx={{
        fontSize: "11px",
        color: "#888888",
        lineHeight: 1.4,
        margin: "0 0 24px 0",
        textAlign: "left",
      }}
    >
      {descriptions.map((description, index) => (
        <>
          {description}
          {index < descriptions.length - 1 && <br />}
        </>
      ))}
    </Box>
  );
}
